import React from 'react';


function Footer() {
    return (<p id ="footer"> Potting Around  Copyright &copy; {new Date().getFullYear()}</p>);
}
export default Footer;